import React from 'react';
import { BET_ACTION_MODAL_TYPE } from '../../enums/betActionModal';
import {useApplicationStore} from "@pascal/pascal-core";

export const FavoriteBetsPopUp = ({ isShowBetActionModal, handleShowBetActionModal, isMobile }) => {
  const { isDemo } = useApplicationStore();

  return (
    <div
      className={`${isMobile() ? 'mob-roulette-t-icon-item' : 'right-top-icon-box'} ${isDemo ? 'disabled' : ''}
              ${isShowBetActionModal === BET_ACTION_MODAL_TYPE.favoriteBets ? 'active' : ''}`}
      onClick={() => handleShowBetActionModal(BET_ACTION_MODAL_TYPE.favoriteBets)}>
      <span className="icon-star"/>
    </div>
  );
};